/**
 * SolarOutlet – Such-Tracking (Theme-Teil)
 * Erfasst: getippte Suchbegriffe (via Predictive-Search-Fetch), abgeschickte Suchen,
 * 0-Treffer und Klicks auf Suchergebnisse. Sendet an den Cloudflare Worker.
 *
 * Der Conversion-Funnel (Produktansicht, Warenkorb, Kauf) kommt aus dem Shopify Web Pixel.
 *
 * Konfiguration ueber window.__soTrack (im Snippet so-search-tracking.liquid gesetzt):
 *   window.__soTrack = { url: 'https://<worker>/collect' };
 */
(function () {
  'use strict';
  var CFG = window.__soTrack || {};
  var ENDPOINT = CFG.url;
  if (!ENDPOINT) return;

  // --- Consent: nur senden, wenn Analytics erlaubt -------------------------
  // Quelle ist die Shopify Consent Tracking API. Das Consent-Tool des Shops
  // (aktuell Complianz, technisch iubenda) meldet die Entscheidung des
  // Besuchers dorthin. Dadurch haengt hier nichts an einem Herstellernamen:
  // ein Toolwechsel erfordert keine Aenderung mehr an dieser Datei.
  // Die Pruefung laeuft pro Event, nicht einmalig beim Laden, damit sie auch
  // dann stimmt, wenn die API beim Seitenaufbau noch nicht bereit war.
  function consentOK() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed();
      }
    } catch (e) {}
    // API nicht geladen oder kein Consent-Tool aktiv -> im Zweifel NICHT
    // tracken (DSGVO-sicher).
    return CFG.assumeConsent === true;
  }

  // --- Anonyme IDs (First-Party-Cookies) -----------------------------------
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, val, maxAgeSec) {
    document.cookie = name + '=' + encodeURIComponent(val) +
      '; path=/; max-age=' + maxAgeSec + '; SameSite=Lax; Secure';
  }
  function sid() {
    var v = getCookie('so_sid');
    if (!v) { v = uuid(); setCookie('so_sid', v, 60 * 60 * 24 * 180); } // 180 Tage
    return v;
  }
  function vid() {
    var v = getCookie('so_vid');
    if (!v) { v = uuid(); setCookie('so_vid', v, 60 * 30); } // 30 Min Session
    else { setCookie('so_vid', v, 60 * 30); } // Sliding-Fenster
    return v;
  }

  // --- Senden --------------------------------------------------------------
  function send(ev) {
    if (!consentOK()) return;
    ev.sid = sid();
    ev.vid = vid();
    ev.ts_client = new Date().toISOString();
    ev.path = location.pathname;
    ev.source = 'theme';
    try {
      var payload = JSON.stringify(ev);
      // text/plain = CORS-safelisted -> kein Preflight, wird auch in Safari/iOS zuverlaessig
      // gesendet. Der Worker parst den Body ohnehin als JSON (unabhaengig vom Content-Type).
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'text/plain;charset=UTF-8' }));
      } else {
        fetch(ENDPOINT, { method: 'POST', body: payload, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, keepalive: true });
      }
    } catch (e) {}
  }

  // --- Predictive-Search-Fetch abfangen (= getippte Begriffe + Trefferzahl) -
  // Nur das FERTIG getippte Wort loggen, nicht jede Zwischenstufe: der zuletzt
  // getippte Stand wird gemerkt und erst nach einer Tipp-Pause gesendet
  // (bzw. beim Ergebnis-Klick / Seitenwechsel). Wird geloescht und neu getippt,
  // entsteht nach der Pause automatisch ein eigener Eintrag.
  var pending = null;        // { q, count } – zuletzt getippter Stand
  var flushTimer = null;
  var lastQuery = '';        // fuer die Zuordnung des Ergebnis-Klicks
  var FLUSH_MS = 1200;

  function flushSearch() {
    if (flushTimer) { clearTimeout(flushTimer); flushTimer = null; }
    if (!pending) return;
    var p = pending; pending = null;
    send({ type: 'search_input', q: p.q, results_count: p.count });
    if (p.count === 0) send({ type: 'search_no_results', q: p.q, results_count: 0 });
  }
  function scheduleFlush() {
    if (flushTimer) clearTimeout(flushTimer);
    flushTimer = setTimeout(flushSearch, FLUSH_MS);
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var urlStr = typeof input === 'string' ? input : (input && input.url) || '';
    var isSuggest = urlStr.indexOf('/search/suggest') !== -1 || urlStr.indexOf('section_id=predictive-search') !== -1;
    // Immer mit window als this aufrufen (sonst "Illegal invocation" bei native fetch).
    var p = origFetch.apply(window, arguments);
    if (!isSuggest) return p;
    var q = decodeURIComponent((urlStr.match(/[?&]q=([^&]*)/) || [])[1] || '').replace(/\+/g, ' ').trim();
    if (!q) return p;
    lastQuery = q;
    return p.then(function (res) {
      try {
        var clone = res.clone();
        clone.text().then(function (html) {
          var count = (html.match(/<product-card-small[\s>]/g) || []).length;
          // Nur merken – gesendet wird erst nach der Tipp-Pause.
          pending = { q: q, count: count };
          scheduleFlush();
        });
      } catch (e) {}
      return res;
    });
  };

  // Letzten getippten Stand nicht verlieren, wenn die Seite verlassen/versteckt wird.
  window.addEventListener('pagehide', flushSearch);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flushSearch();
  });

  // --- Abgeschickte Suche (Enter / Button) ---------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('action') == null) return;
    if ((form.getAttribute('action') || '').indexOf('/search') === -1) return;
    var input = form.querySelector('input[type="search"], input[name="q"], .search-field');
    var q = input && input.value ? input.value.trim() : '';
    flushSearch(); // den fertig getippten Begriff sichern
    if (q) send({ type: 'search_submit', q: q });
  }, true);

  // --- Klick auf ein Suchergebnis ------------------------------------------
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    // Nur innerhalb eines Such-Kontexts zaehlen
    var inSearch = a.closest('.thb-predictive-search, .search-drawer, .header-mobile-search, [id*="predictive-search"], #shopify-section-main-search');
    if (!inSearch) return;
    var card = a.closest('[data-product-handle], product-card-small, product-card');
    var handle = (card && card.getAttribute('data-product-handle')) ||
      (a.getAttribute('href').match(/\/products\/([^?#]+)/) || [])[1] || null;
    flushSearch(); // zuerst den fertig getippten Suchbegriff loggen
    send({
      type: 'search_result_click',
      q: lastQuery,
      product_handle: handle,
      product_id: card && card.getAttribute('data-id') || null,
    });
  }, true);
})();
